module.exports = __webpack_public_path__ + "static/media/bank-1.3bbb438f.svg";